export function autoCapitalize<T>(value: T): string | T {
  return typeof value === 'string'
    ? value?.toLowerCase()?.replace(/(?:^|\s)\S/g, c => c?.toUpperCase())
    : value
}
